// extracted by mini-css-extract-plugin
module.exports = {"header":"TimeSheet_header__qAK60","menu":"TimeSheet_menu__3HGDq","tableContainer":"TimeSheet_tableContainer__23DBa","table":"TimeSheet_table__3Hnj_"};